module.exports = __webpack_public_path__ + "img/img-box-covid19-right.c90c8988.png";